/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoteTemplates/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import Template from './Template/index'
import Templates from './Templates/index'



/** @type {import('Simple/types.js').View} */
export default function NoteTemplates({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Templates'
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<fromFlow.When is={flowValue === 'Templates'}>
<Templates
  viewPath={`${viewPath}/Templates`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Template'}>
<Template
  viewPath={`${viewPath}/Template`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}